module.exports = __webpack_public_path__ + "./Ilin_d798cb4623a714b37dfe541525ca9abb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2022/Ilin.jpg
// module id = 554
// module chunks = 0